import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { BOOKING_TIMES } from '../constants/SearchTutor';
import generateRandomDisabledDays from '../utils/generateRandomDisabledDays';
import ShadowBtn from '../../../Components/ShadowBtn';
import CustomCalendar from '../../../Components/CustomCalendar';

const BookingModal = ({
  tutorname,
  step,
  setStep,
  setShowAppointmentModal,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
}) => {
  const handleDateConfirm = () => {
    if (selectedDate) setStep(2);
  };

  const handleTimeConfirm = () => {
    if (selectedTime) setStep(3);
  };

  const resetBooking = () => {
    setSelectedDate(null);
    setSelectedTime(null);
    setShowAppointmentModal(false);
    setStep(1);
    setSelectedDate(new Date());
  };

  const disabledDays = useMemo(() => {
    return generateRandomDisabledDays(5);
  }, []);

  return (
    <div className="w-full rounded-lg bg-white px-10 py-6 shadow-lg lg:min-w-[680px] lg:px-[88px]">
      {step === 1 && (
        <>
          <h2 className="fredoka mb-6 text-center text-2xl font-medium leading-9 text-[#012E33] ">
            {tutorname} Availability
          </h2>
          <CustomCalendar
            selected={selectedDate}
            onSelect={setSelectedDate}
            disabledDays={disabledDays}
          />
          <div className="mt-8 flex items-center">
            <ShadowBtn text="Confirm Date" onClick={handleDateConfirm} />
          </div>
        </>
      )}

      {step === 2 && (
        <div>
          <h2 className="fredoka mb-6 text-center text-2xl font-medium leading-9 text-[#012E33] ">
            {tutorname} Availability
          </h2>
          <div className=" mb-8 flex items-center justify-center gap-4">
            <img src="/icons/chevron-left.svg" alt="" />
            <p className=" fredoka text-center text-base font-bold leading-5 text-teal-900">{`${selectedDate ? format(selectedDate, 'do MMMM yyyy') : ''}`}</p>
            <img src="/icons/chevron-right.svg" alt="" />
          </div>

          {BOOKING_TIMES.map((Times, index) => (
            <div key={index} className="mb-2 flex flex-wrap justify-center gap-4">
              {Times.map((time) => (
                <button
                  key={time}
                  onClick={() => setSelectedTime(time)}
                  className={`px-6 fredoka py-3 rounded-full text-base
                                            transition-colors border ${
                                              selectedTime === time
                                                ? 'border-[#0E9F6E] bg-[#0E9F6E] text-white'
                                                : 'border-[#014451] text-[#678285]'
                                            }
                                            hover:bg-[#0E9F6E] hover:border-[#0E9F6E] hover:text-white
                                        `}
                >
                  {time}
                </button>
              ))}
            </div>
          ))}

          <div className="mt-4 flex items-center">
            <ShadowBtn text="Confirm Date" onClick={handleTimeConfirm} />
          </div>
        </div>
      )}

      {step === 3 && (
        <div className=" mx-auto flex w-[400px] flex-col items-center justify-center gap-[19px] text-center">
          <div className=" flex flex-col items-center justify-center gap-2">
            <img src="/images/icons-celebration.png" alt="" className="h-20 w-20 object-cover" />
            <p className="fredoka text-xl font-medium leading-7 text-[#012E33]">Great Work!</p>
          </div>
          <p className="fredoka text-2xl font-semibold leading-9 text-[#012E33]">
            Your Free Tutoring Session is booked for{' '}
            {selectedDate ? format(selectedDate, 'do MMMM yyyy') : ''} between {selectedTime}
          </p>
          <p className=" fredoka text-center text-sm leading-5 text-gray-500">
            You&apos;ll receive an email confirmation and a calendar invite on your registered email
            address.
          </p>

          <ShadowBtn text="Continue" onClick={resetBooking} />
        </div>
      )}
    </div>
  );
};

export default BookingModal;
